package com.ilussobsa

import com.ilussobsa.Strings.appName
import com.ilussobsa.sdk.*
import com.ilussobsa.utils.*
import com.ilussobsa.views.*
import com.ilussobsa.views.dialogs.GenericDialog
import com.ilussobsa.views.dialogs.userModal
import com.lightningkite.kiteui.*
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.reactive.AppState
import com.lightningkite.kiteui.reactive.PersistentProperty
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.appBase
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.networking.BulkFetcher
import com.lightningkite.now
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import kotlinx.coroutines.*
import kotlinx.serialization.Serializable


@Serializable
enum class ApiOption(val apiName: String, val http: String, val ws: String) {
    Prod("", "https://backend.ilussoauctions.com", "wss://ws.backend.ilussoauctions.com"),
    /*Demo(
        "Demo",
        "https://demo.backend.brandspecificauctions.com",
        "wss://ws.demo.backend.brandspecificauctions.com"
    ),*/
    Staging(
        "Staging",
        "https://staging.api.ilussoauctions.com",
        "wss://ws.staging.api.ilussoauctions.com"
    ),
    Dev("Dev", "https://ilussooffmarket-api.cs.lightningkite.com", "wss://ws.ilussooffmarket-api.cs.lightningkite.com"),
    Jivie("Joseph's", "https://jivie.lightningkite.com", "wss://jivie.lightningkite.com"),
    LocalNet("LocalNet", "http://192.168.1.135:8941", "ws://192.168.1.135:8941"),
    Local("Local", "http://localhost:8080", "ws://localhost:8080"),
    SameServer("SameServer", "", ""),
    ;

    companion object {
        var selectedIndex = 0
    }

    val baseFetcher
        get() = BulkFetcher(
            "$http/meta/bulk",
            "$ws?path=/multiplex"
        )

    val api get() = LiveApi2(baseFetcher)
}

val fcmToken: Signal<String?> = Signal(null)
val setFcmToken = { token: String -> fcmToken.value = token }

expect fun getDefaultServerBackend(): ApiOption

val selectedApi = PersistentProperty<ApiOption>("apiOption", getDefaultServerBackend())

val useNewMenu = PersistentProperty<Boolean>("useNewMenu", false)
val tabBehavior = PersistentProperty<TabBehavior>("tabBehavior", TabBehavior.NextInTab)

@Serializable
enum class TabBehavior(val title: String) {
    NextInTab("Show Next in Tab"),
    FollowVehicle("Follow Vehicle"),
    Clear("Clear Vehicle")
}

val useTwoPane = remember { WindowInfo().width > 1000.dp }

lateinit var mainNavigatorGlobalIsBad: ScreenNavigator

interface AdminOnly : Page

fun ViewWriter.app(main: ScreenNavigator, dialog: ScreenNavigator) {
    ExternalServices.baseContext = context
    mainNavigatorGlobalIsBad = main
//    if (appThemePreference.value == null) {
////        when (context.darkMode) {
////            true -> appThemePreference.value = ThemePreference.Dark
////            false -> appThemePreference.value = ThemePreference.Light
////            else -> {}
////        }
//    }
    if (appNavPreference.value == null) {
        when (Platform.current) {
            Platform.iOS -> appNavPreference.value = NavPreference.BottomTabs
            Platform.Android -> appNavPreference.value = NavPreference.BottomTabs
            Platform.Web -> {
                if (Platform.usesTouchscreen)
                    appNavPreference.value = NavPreference.BottomTabs
                else
                    appNavPreference.value = NavPreference.Top
            }

            Platform.Desktop -> appNavPreference.value = NavPreference.Top
        }
    }

    val big = remember { AppState.windowInfo().width > 1000.dp }
//    appNavFactory.value = ViewWriter::appNavTopAndLeft
//    AppScope.reactiveScope {
//        val screenWidth = WindowInfo.await()
//        val newBig = screenWidth.width > 1000.dp
//        if (big != newBig) {
//            appNavFactory set if (newBig) ViewWriter::appNavTopAndLeft else ViewWriter::appNavHamburger
//        }
//        big = newBig
//    }

    //ffmpeg -i loginback.mp4 -s 720x480 -b

    defaultAppTheme.onNext - OuterSemantic.onNext - appBase(main, dialog) {
        AppScope.reactiveSuspending {
            val session = currentUserSessionNullable.await() ?: return@reactiveSuspending
            fcmToken.await()?.let { token ->
                session.fcmToken.upsert(FcmToken(token, session.userId, true))
            }
        }

        // Really evil hack forces data to reload whenever we navigate screens
        // Not sure if this is a good idea, but it should stymie some complaints about the cache.
//        AppScope.reactiveScope {
//            val session = currentSessionNullable() ?: return@reactiveScope
//            val screen = mainScreenNavigator.currentScreen()
//            session.refresh()
//        }

        AppScope.reactiveSuspending {
            if (currentUserSessionNullable.invoke() == null) return@reactiveSuspending
            val permission = notificationPermissions()
            when (permission) {
                false -> {}

                true -> {
                    fcmSetup()
                }

                null -> {
                    dialogPageNavigator.navigate(GenericDialog(
                        "BSA would like to send you notifications about auction events."
                    ) {
                        launch {
                            requestNotificationPermissions()
                        }
                    })
                }
            }
        }

        AppScope.reactiveScope {
            if (pageNavigator.currentPage() is AdminOnly && currentUser.awaitNotNull().role < UserRole.Manager)
                pageNavigator.replace(DashboardScreen())
        }
        OuterSemantic.onNext - swapView {
            swapping(
                current = {
                    when {
                        pageNavigator.currentPage() is FullScreenAuction -> ViewWriter::appNavAuctionJail
                        big() -> ViewWriter::appNavTopAndLeftWithLogo
                        else -> ViewWriter::appNavHamburger2
                    }
                },
                views = {
                    it(this) {

                        appName = "iLusso BSA"

                        ::appLogo {
                            Resources.ilussoFullLogo(defaultAppTheme)
                        }

                        ::exists {
                            (pageNavigator.currentPage() as? ControlsNavVisibility)?.run { showNav() } ?: true
                        }

                        val notificationCount = remember {
                            currentUserSessionNullable()?.let {
                                val after = it.me()?.notificationsLastCheckedAt ?: return@let null
                                it.notification.watch(
                                    Query(
                                        condition = condition {
                                            it.at.gt(after) and it.receiver.eqNn(currentUser()?._id)
                                        },
                                        limit = 100
                                    )
                                )().size.takeUnless { it == 0 }
                            }
                        }

                        actions = listOf(
//                            NavLink(
//                                { Strings.notifications },
//                                {
//                                    if (notificationCount() != null) Icon.notificationFilled
//                                    else Icon.notification
//                                },
//                                { notificationCount() },
//                            ) { { NotificationsScreen() } },
                            NavCustom(
                                square = {
                                    centered - link {
                                        col {
                                            centered - sizeConstraints(width = 2.rem, height = 2.rem) - frame {
                                                centered - sizeConstraints(width = 1.5.rem, height = 1.5.rem) - icon {
                                                    ::source {
                                                        if (notificationCount()?.let { it > 0 } == true) Icon.notificationFilled
                                                        else Icon.notification
                                                    }
                                                }
                                                sizeConstraints(width = 1.rem, height = 1.rem) - atTopEnd - frame {
                                                    padding = 0.dp
                                                    ::shown { notificationCount()?.let { it > 0 } == true }
                                                    themeChoice += ThemeDerivation {
                                                        it.copy(
                                                            "belllbl",
                                                            background = it[DangerSemantic].theme.foreground,
                                                            foreground = it[DangerSemantic].theme.background,
                                                            font = it.font.copy(size = 0.5.rem),
                                                            cornerRadii = CornerRadii.Constant(10.rem),
                                                        ).withBack
                                                    }
                                                    centered - text {
                                                        padding = 0.dp
                                                        ::content { "${notificationCount() ?: 0}" }
                                                        align = Align.Center
                                                    }
                                                }
                                            }
                                            centered - subtext {
                                                ::shown { big() }
                                                ::content { "Alerts" }
                                            }
                                        }

                                        ::to { { NotificationsScreen() } }
                                    }
                                },
                            ),
                            NavCustom(
                                square = {
                                    centered - menuButton {
                                        preferredDirection = PopoverPreferredDirection.belowCenter
                                        opensMenu {
                                            userModal { closePopovers() }
                                        }
                                        col {
                                            centered - sizeConstraints(width = 2.rem, height = 2.rem) - image {
                                                description = ""
                                                ::source {
                                                    currentUser()?.profilePicture?.location?.let(::ImageRemote)
                                                        ?: Icon.avatar.toImageSource(Color.black)
                                                }
                                            }
                                            centered - subtext {
                                                ::shown { big() }
                                                ::content {
                                                    currentUser()?.name ?: "-"
                                                }
                                            }
                                        }
                                    }
                                },
                            )
                        )
                        ::navItems{
                            listOf(
                                NavLink(Strings.dashboard, Icon.dashboard, { DashboardScreen() }),
                                NavLink(
                                    title = { Strings.liveAuctions },
                                    icon = { Icon.liveAuctionSmall },
                                    destination = { { AuctionsScreen() } }),
                                NavLink(
                                    title = { Strings.upcomingAuctions },
                                    icon = { Icon.upcomingAuctionSmall },
                                    destination = { { UpcomingAuctionsScreen() } }),
                                NavLink(
                                    title = { Strings.pastAuctions },
                                    icon = { Icon.pastAuctionSmall },
                                    destination = { { PastAuctionsScreen() } }),
                                NavLink(
                                    title = { Strings.findVehicles },
                                    icon = { Icon.search },
                                    destination = { { SearchScreen() } }),
                                NavLink(
                                    title = { Strings.uploadNew },
                                    icon = { Icon.publish },
                                    destination = { { TakeNewVehicleImagesScreen() } },
                                    hidden = { (currentUser()?.role ?: UserRole.Anonymous) < UserRole.Manager }),
                                NavLink(
                                    title = { Strings.sellingCenter },
                                    icon = { Icon.sell },
                                    destination = { { SellingCenterScreen() } },
                                    hidden = { (currentUser()?.role ?: UserRole.Anonymous) < UserRole.Manager }),
                                NavLink(
                                    title = { Strings.purchases },
                                    icon = { Icon.boughtSmall },
                                    destination = { { PurchasesScreen() } },
                                    hidden = { currentUser()?.role?.let { it > UserRole.Customer } == true }
                                ),
                                NavLink(
                                    title = { Strings.users },
                                    icon = { Icon.people },
                                    destination = { { UsersScreen().apply {} } },
                                    hidden = { (currentUser()?.role ?: UserRole.Anonymous) < UserRole.Manager }),
                            )
                        }
                    }
                }
            )
        }
        connectivityDialog()
    }
}

//val ViewWriter.standardMaxWidth get() = gravity(Align.Center, Align.Stretch) - sizeConstraints(width = 70.rem)
val ViewWriter.standardMaxWidth get() = sizeConstraints(maxWidth = 70.rem)

fun ViewWriter.connectivityDialog() = dismissBackground {
    reactiveScope {
        if (Connectivity.lastConnectivityIssueCode() in Connectivity.tooMuchCodes) {
            Exception("Too many requests.").report()
        }
    }
    ::shown { Connectivity.fetchGate.retryAt() != null }
    onClick { }
    centered - card - col {
        h2("Connectivity Issues")
        col {
            ::shown { Connectivity.lastConnectivityIssueCode() !in Connectivity.tooMuchCodes }
            text("Your access to the internet has some problems.")
            text("Please reconnect to the internet to continue.")
        }
        col {
            ::shown { Connectivity.lastConnectivityIssueCode() in Connectivity.tooMuchCodes }
            text("You're requesting too much.")
            text("Please wait for a minute and retry.")
        }
        text {
            launch {
                while (true) {
                    delay(200)
                    content =
                        "Retrying in ${((Connectivity.fetchGate.retryAt() ?: now()) - now()).inWholeSeconds + 1} seconds"
                }
            }
        }
        row {
            expanding - danger - button {
                centered - text("Log Out")
                onClick {
                    Connectivity.fetchGate.abandon()
                    mainPageNavigator.navigate(LogInScreen())
                }
            }
            expanding - button {
                centered - text("Retry now")
                onClick {
                    Connectivity.fetchGate.retryNow()
                }
            }
        }
    }
}